export type PropsFactory = (name: string) => Record<string, unknown>;
